module.exports = __webpack_public_path__ + "img/headCoin.bc65c3e9.svg";